module.exports = __webpack_public_path__ + "static/media/article-redesign.6cf460ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blocks/article-redesign.png
// module id = 85
// module chunks = 0